import LocalizedClientLink from "@/utils/LocalizedClientLink";
import { useRouter } from "next/router";
import { useCustomApi } from '@/contexts/CustomApiContext';
import { useLanguage } from '@/contexts/LanguageContext';
import { useEffect, useMemo } from 'react';
import { useLocalizedRouter } from "@/utils/LocalizedPush";

const Breadcrumb = ({ setIsTitleClicked , handle_ar}) => {

  console.log(handle_ar, "handle_ar ")

  const router = useRouter();
  const { state } = useCustomApi();
  const { language, toggleLanguage } = useLanguage();
     const { push } = useLocalizedRouter()
  
  // Use useMemo to ensure isRTL is recalculated when language changes
  const isRTL = useMemo(() => language === "ar", [language]);

  useEffect(() => {
    console.log('Language changed:', language);
    console.log('isRTL value:', isRTL);
  }, [language, isRTL]);

  const categories = state?.customNewCategories?.product_categories || [];

  // console.log(categories, "categories")

  // Remove query params and extract path segments
  const pathWithoutQuery = router.asPath.split("?")[0];
  const pathSegments = pathWithoutQuery.split("/").filter((segment) => segment);

  // Remove the region (first segment)
  const filteredPaths = pathSegments.slice(1);

  const capitalize = (str) =>
    str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");

  const handleBreadcrumbClick = (displayText, href) => {
    if (displayText === "Product") {
      push("/shop");
    } else {
      setIsTitleClicked(true);
    }
  };

  return (
    <nav
      className="container bg-white pt-5 md:py-5 text-sm md:text-base tracking-wider text-gray-600"
      aria-label="Breadcrumb"
    >
      <ol className="flex items-center space-x-1 sm:space-x-1 overflow-x-auto">
        <li>
          <LocalizedClientLink href="/">
            <p className="text-gray-400 hover:text-gray-600 font-normal font-primary"> {!isRTL ? "Home" : "الرئيسية" }</p>
          </LocalizedClientLink>
        </li>
        {filteredPaths.map((path, index) => {
          const href = "/" + filteredPaths?.slice(0, index + 1).join("/");
          const isLast = index === filteredPaths?.length - 1;
          const formattedPath = capitalize(
            decodeURIComponent(path.replace(/-en/g, "").replace(/-/g, " "))
          );
          // Try to find the matching category
          const matchedCategory = categories?.find(cat => {
            const catName = capitalize(cat.name || "");
            return catName === formattedPath;
          });

          // Use name_ar if RTL and match found
          const displayText = isRTL && matchedCategory?.metadata?.name_ar
            ? ( isRTL ? matchedCategory.metadata.name_ar : matchedCategory.name)
            : formattedPath
console.log(displayText,"displayText");

          const dealsdisplay = displayText === "Deals" ? (isRTL ? "التخفيضات" : "Deals") : "";
          const comparedisplay = displayText === "Compare" ? (isRTL ? "مقارنة المنتجات" : "Compare") : "";
          const productDisplay = displayText === "Product" ? (isRTL ? `المنتج ${handle_ar}` : "Product") : "";
          const cartDisplay = displayText === "Cart" ? (isRTL ? 'سلة المشتريات' : "Cart") : "";
          const shopProductsDisplay = displayText === "Shop" ? (isRTL ? 'المتجر' : "Shop") : "";
          return (
            <li key={index} className="flex items-center">
              <span className="mx-2 text-gray-400">/</span>
              {isLast ? (
                <span className="text-[#262626] font-primary font-semibold tracking-wide line-clamp-1">
                  {shopProductsDisplay || cartDisplay || dealsdisplay || productDisplay || comparedisplay || displayText}
                </span>
              ) : (
                <LocalizedClientLink href={href} onClick={() => handleBreadcrumbClick(displayText, href)}>
                  <p className="text-gray-600 hover:text-gray-800">{displayText}</p>
                </LocalizedClientLink>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
